<template>
  <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 1L6 12 1 7" stroke="#00B382" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
